/**
 * Back-to-top behavior (vanilla JS).
 * - Adds a circular button with a Material Icons arrow.
 * - Shows after scrolling down; smooth-scrolls to top on click.
 */
(function (Drupal, once) {
  'use strict';

  Drupal.behaviors.backToTop = {
    attach(context) {
      // Ensure we run only once per page.
      once('back-to-top-init', 'body', context).forEach(() => {
        const btn = document.createElement('button');
        btn.className = 'back-to-top';
        btn.type = 'button';
        btn.setAttribute('aria-label', Drupal.t('Back to top'));
        btn.setAttribute('title', Drupal.t('Back to top'));
        // Material Icons webfont is already available.
        btn.innerHTML = '<span class="material-icons" aria-hidden="true">🡡</span>';

        document.body.appendChild(btn);

        // Show / hide on scroll (throttled via rAF).
        let ticking = false;
        const toggleBtn = () => {
          const shouldShow = window.scrollY > 300;
          btn.classList.toggle('is-visible', shouldShow);
          ticking = false;
        };
        const onScroll = () => {
          if (!ticking) {
            window.requestAnimationFrame(toggleBtn);
            ticking = true;
          }
        };
        window.addEventListener('scroll', onScroll, { passive: true });
        toggleBtn(); // Initial state.

        // Click: scroll to top (respect reduced motion).
        const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        btn.addEventListener('click', () => {
          if (prefersReduced) {
            window.scrollTo(0, 0);
          } else {
            window.scrollTo({ top: 0, behavior: 'smooth' });
          }
        });

        // Keyboard support (Space/Enter).
        btn.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            btn.click();
          }
        });
      });
    }
  };
})(Drupal, once);
